export default "__VITE_ASSET__Dx5FIIyr__"